import { Box } from '@mui/material';
import { Outlet } from 'react-router';

export function Options() {
  return (
    <Box sx={{ height: 'calc(100vh - 96px)' }}>
      <title>IR3 | Options</title>
      <Outlet />
    </Box>
  );
}
